const cleanText = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();

// Caregiver-facing labels only - never the raw internal sourceType string
// (see the "does not expose raw source types" test). This is presentation
// wording for the "View sources" list, not a classification used anywhere
// else in the Profile Contract.
const SOURCE_TYPE_LABELS = Object.freeze({
  care_knowledge: 'Caregiver note',
  typed_long_note: 'Caregiver note',
  quick_check_in: 'Quick check-in',
  dictated_text: 'Dictated note',
  care_knowledge_document: 'Uploaded document',
  care_knowledge_photo: 'Photo',
  care_knowledge_screenshot: 'Screenshot',
  profile_document: 'Uploaded document',
  doctor_note: 'Clinical note',
  file_import: 'Imported file',
  ocr_text: 'Scanned document',
  email: 'Email',
  incoming_email: 'Email',
  forwarded_email: 'Email',
});

const humanSourceTypeLabel = (sourceType) => SOURCE_TYPE_LABELS[sourceType] || 'Care record';

export const normalizeChapterProvenance = (sourceRefs = [], idPrefix = 'chapter-source') => {
  const refs = Array.isArray(sourceRefs) ? sourceRefs : [];
  const sources = [];
  const records = [];
  const identities = new Set();

  refs.forEach((source, index) => {
    const sourceTypeLabel = humanSourceTypeLabel(source?.sourceType);
    const label = cleanText(
      source?.sourceTitle
      || source?.title
      || (sourceTypeLabel !== 'Care record' ? sourceTypeLabel : '')
    );
    const id = source.sourceId || `${idPrefix}-${index}`;
    const identity = source.sourceId || `${label}|${index}`;
    if (!label || identities.has(identity)) return;
    identities.add(identity);
    sources.push({ id, label });
    records.push({
      id,
      label,
      sourceTypeLabel,
      ...(source?.authorName ? { authorName: source.authorName } : {}),
      ...(source?.sourceCollection === 'careSources' ? {captureId:source.sourceId} : {}),
      capturedAt: source?.capturedAt || source?.confirmedAt || source?.createdAt || null,
      excerpt: cleanText(source?.sourceText || source?.sourceContext || ''),
    });
  });
  if (sources.length) return { mode: 'named_sources', sources, records };

  const sourceIds = new Set(refs.map((source) => source?.sourceId).filter(Boolean));
  return sourceIds.size ? { mode: 'source_count', sourceCount: sourceIds.size } : undefined;
};
